<div class="desktop-full-screen-overlay--flex">
  <div class="withdraw-form-container">
    <app-form-container [title]="'webPos.Withdraw' | translate" (onCancel)="close()"
      (onSubmit)="createFinancialTransaction()" [confirmDisabled]="isSubmitDisabled">
      <ng-container form-body>
        <form [formGroup]="form" class="withdraw-form">
          <app-dropdown [label]="'webPos.ValuableType' | translate" [options]="valuableTypeOptions"
            formControlName="valuableType">
          </app-dropdown>

          @if (hasNominals) {
          <div [formGroup]="form.controls.denominationRowsGroup" class="nominals-container">
            <div formArrayName="rows" id="withdrawDenominationRows" class="withdraw-form__row-container">
              <div *ngFor="let rowCtrl of rows.controls; let i = index" class="withdraw-form__row" [formGroupName]="i">
                <div class="withdraw-form__row-counter">
                  <span>{{ i + 1 }}.</span>
                </div>

                <app-dropdown
                  class="withdraw-form__row-value"
                  [label]="'webPos.Value' | translate"
                  [options]="nominalOptions"
                  formControlName="value">
                </app-dropdown>

                <app-form-input
                  class="withdraw-form__row-pieces"
                  [label]="'webPos.CountOfPieces' | translate"
                  [type]="FormInputType.Number"
                  formControlName="numberOfItems">
                </app-form-input>

                <div class="withdraw-form__row-add-button">
                  <fa-icon [icon]="['fas', 'circle-plus']" (click)="addRow()"></fa-icon>
                </div>
                <div class="withdraw-form__row-delete-button" [class.withdraw-form__row-delete-button--disabled]="rows.length <= 1">
                  <fa-icon [icon]="['fas', 'trash']" (click)="removeRow(i)"></fa-icon>
                </div>
              </div>
            </div>

            <div class="withdraw-form__total">
              <span>{{ 'webPos.Closings.TotalValue' | translate }}:</span>
              <span>{{ totalNominalValue | number }} {{ selectedPaymentType?.Currency || loginService.user.CurrencyCode | currencymap }}</span>
            </div>
          </div>
          } @else {
          <app-form-input [label]="'webPos.Value' | translate" [placeholder]="" [type]="FormInputType.Number" formControlName="value"></app-form-input>
          }

          @if (availableAmount !== null) {
            <div class="withdraw-available-amount" [class.withdraw-available-amount--insufficient]="amountInsufficient">
              {{ 'webPos.AvailableValue' | translate }}: {{ availableAmount | hcurrency : (loginService.user?.CurrencyCode) }}
            </div>
            @if (amountInsufficient) {
              <div class="withdraw-available-amount--error">
                {{ 'webPos.Errors.InsufficientValue' | translate }}
              </div>
            }
          }
          <app-dropdown [label]="'webPos.Reason' | translate" [options]="reasonOptions" formControlName="reason"></app-dropdown>
          <app-form-textarea [label]="'webPos.Note' | translate" formControlName="note"></app-form-textarea>
        </form>
      </ng-container>
    </app-form-container>
  </div>
</div>